import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { Subscription } from 'rxjs';
import { AppState } from '../../../../../../core/reducers';
import { ExternalAccessEditComponent } from '../external-access-edit/external-access-edit..component';
import { QrveyService } from '../../../../../../core/lists/_services/qrvey.service';
import { UsersAccessListComponent } from '../../users-access-list/users-access-list.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-external-access-list',
  templateUrl: './external-access-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalAccessListComponent implements OnInit, OnDestroy {
  dataSource: any;
  displayedColumns = ['category', 'type', 'entity', 'pages', 'actions'];
  private subscriptions: Subscription[] = [];
  private appId = null;

  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private qrveyService: QrveyService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.app_id) {
        this.appId = params.app_id;
        this.loadExternalAccessList();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadExternalAccessList() {
    this.subscriptions.push(
      this.qrveyService.getTeamsByApplication(this.appId).subscribe((res) => {
        this.dataSource = res.data?.filter((e) => e.type !== 'USER');
        this.cdr.detectChanges();
      }),
    );
  }

  deleteExternalAccess(_item) {
    const _title = 'Delete External Access';
    const _description = 'Are you sure you want to delete External Access?';
    const _waitDescription = 'Deleting...';

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDescription);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.subscriptions.push(
        this.qrveyService.removeInternalAccess(this.appId, _item.id, _item.type).subscribe(() => {
          this.loadExternalAccessList();
          this.cdr.detectChanges();
        }),
      );
    });
  }

  editExternalAccess(_item) {
    const dialogRef = this.dialog.open(ExternalAccessEditComponent, {
      data: { mode: 'UPDATE', _item },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadExternalAccessList();
    });
  }

  createExternalAccess() {
    const dialogRef = this.dialog.open(ExternalAccessEditComponent, {
      data: { mode: 'CREATE' },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadExternalAccessList();
    });
  }

  contactsView(ele) {
    let entities = '';
    const entityIds = new Set(ele.entities?.map((e) => e.id));
    entityIds.forEach((element) => (entities = entities + '&entity_id=' + element));

    const dialogRef = this.dialog.open(UsersAccessListComponent, {
      data: {
        type: 'CONTACT',
        ids: [ele.team_id],
        entityId: ele.entities && ele.entities.length !== 0 ? entities : '',
      },
    });
    dialogRef.afterClosed().subscribe();
  }
}
